import { Injectable } from '@angular/core';
import Papa from 'papaparse';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppService } from 'src/app/app.service';
import { environment } from 'src/environments/environment';
import { CacheService } from 'src/app/cache.service';
import { Token } from 'src/app/app.model';
import { TemplateService } from 'src/app/templates/services/template.service';
import { get } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  private params = new HttpParams();
  private appUrl = environment.apiUrl;

  constructor(private appService: AppService, private cacheService: CacheService,
    private http: HttpClient, private templateService: TemplateService) { }

  async templateServiceInit() {
    try {
      if (get(this.appService.userData, 'userId')) {
        const templateResponse = await this.templateService.getTemplateList(this.appService.userData.userId);
        const {features: featureFlag} = templateResponse;
        console.log(featureFlag);
        this.templateService.setTemplateFeatureFlags = featureFlag;
        return this.templateService.getTemplateFeatureFlags;
      } else {
        return {};
      }
     } catch (error) {
      console.log(error);
     }
  }

  async validateASINFREQUENCYCSVFromURL(csvUrl, maxASINPerWeek: number, maxASINPerMonth: number): Promise<string[]> {
    try {
      const response = await fetch(csvUrl);
      const csvText = await response.text();

      const results: any = await new Promise((resolve, reject) => {
        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: results => resolve(results),
          error: error => reject(error),
        });
      });

      const data = results.data;
      const errors:any = [];

      // Validate header
      const expectedHeaders = ['ASIN', 'FREQUENCY'];
      const actualHeaders = results.meta.fields;

      if (
        actualHeaders.length !== 2 ||
        actualHeaders[0] !== expectedHeaders[0] ||
        actualHeaders[1] !== expectedHeaders[1]
      ) {
        errors.push("CSV headers must be exactly: 'ASIN' and 'FREQUENCY'");
      }

      const allowedFrequencies = ['WEEK', 'MONTH'];
      const seenCombinations = new Set();
      const frequency_week_set = new Set();
      const frequency_month_set = new Set();
      if (data && data.length === 0) {
        errors.push("CSV file is empty. Please upload a valid CSV file.");
      } else if (data && data.length > 0) {
        data.forEach((row, index) => {
          const rowNumber = index + 2; // +2 because of header row
          if (row?.FREQUENCY === 'WEEK') {
            frequency_week_set.add(`${row?.ASIN?.trim()}${row?.FREQUENCY?.trim()}`);
          } else if (row?.FREQUENCY === 'MONTH') {
            frequency_month_set.add(`${row?.ASIN?.trim()}${row?.FREQUENCY?.trim()}`);
          }
          // Validate FREQUENCY values
          if (!allowedFrequencies.includes(row?.FREQUENCY)) {
            errors.push(`Row ${rowNumber}: FREQUENCY must be 'WEEK' or 'MONTH', found '${row?.FREQUENCY}'`);
          }
  
          // Check for duplicate combination
          const key = `${row?.ASIN?.trim()}|${row?.FREQUENCY?.trim()}`;
          if (seenCombinations.has(key)) {
            errors.push(`Row ${rowNumber}: Duplicate combination of ASIN and FREQUENCY found: '${row?.ASIN}', '${row?.FREQUENCY}'`);
          } else {
            seenCombinations.add(key);
          }
        });
      }
      

      if (frequency_week_set.size > maxASINPerWeek ) {
        errors.push(`Cannot have more than ${maxASINPerWeek} unique ASINs in WEEK.`);
      }
      if (frequency_month_set.size > maxASINPerMonth ) {
        errors.push(`Cannot have more than ${maxASINPerMonth} unique ASINs in MONTH.`);
      }

      // Output result
      if (errors.length === 0) {
        return [];
      } else {        
        return errors;
      }
    } catch (err) {
      console.error("Failed to fetch or parse CSV:", err);
      return ["Failed to fetch or parse CSV. Please check the URL and try again."];
    }
  }

}
